import React from 'react';
import { DragHandleHorizontalIcon } from '@radix-ui/react-icons';
import { ElevatedButton } from '@producer/ui-kit';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';

import type { CrewGroupBy } from './crew-list';

type CrewGroupingOption = {
  label: string;
  value: CrewGroupBy;
};

// Three of the four values `CrewGroupBy` supports. `role` is deliberately not offered: with the
// roles CSV behind the role picker, grouping by it produces a group per person on most crews,
// which is a list with extra headers rather than a grouping.
const OPTIONS: CrewGroupingOption[] = [
  { label: 'No grouping', value: null },
  { label: 'By department', value: 'department' },
  { label: 'By team', value: 'team' },
];

type CrewGroupingDropdownProps = {
  value: CrewGroupBy;
  onChange: (value: CrewGroupBy) => void;
};

/**
 * The crew list's "Group by" control. Mirrors the task list's `GroupingDropdown` idiom
 * (`DropdownMenu` + `ElevatedButton` trigger), but state is not a MobX store — task grouping
 * persists across several screens, crew grouping is per-screen, and the callers already own their
 * own `useState` for filtering.
 */
export const CrewGroupingDropdown: React.FC<CrewGroupingDropdownProps> = ({ value, onChange }) => {
  const items = OPTIONS.map((option) => ({
    title: option.label,
    onCheckedChange: () => {
      if (value !== option.value) onChange(option.value);
    },
    isChecked: value === option.value,
  }));

  return (
    <DropdownMenu
      items={items}
      trigger={
        <div>
          <ElevatedButton text="Grouping" icon={<DragHandleHorizontalIcon />} />
        </div>
      }
    />
  );
};
